<template>
  <div class="datalink-header">
    <button class="button white-button" @click="gotoHistory">
      <i class="icon-arrow-left" aria-hidden="true" />
      {{ "datalink.back" | t }}
    </button>
    <h1 class="is-1 title">
      {{ info.created | dateFormat("Y/MM/dd HH:mm") }}
    </h1>
    <div class="subtitle">
      <ul class="sub-list">
        <li>
          <span class="list-title">{{ "datalink.originalFiles" | t }}</span>
          <span class="list-value">{{ info.files_total }}</span>
        </li>
        <li>
          <span class="list-title">{{ "datalink.sentToVirtusize" | t }}</span>
          <span class="list-value">{{ info.sent | dateFormat("Y/MM/dd HH:mm") }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  methods: {
    gotoHistory() {
      this.$router.push({ name: "datalink" });
    },
  },
};
</script>

<style scoped lang="scss">
.datalink-header {
  margin-bottom: 20px;
}

.sub-list {
  display: flex;
  font-size: 10px;

  li {
    margin-right: 10px;
  }

  .list-title {
    margin-right: 5px;
    color: $gray-700;
  }
}
</style>
